module.exports = __webpack_public_path__ + "media/widgets/documents_download-4146bb71.png";